// extracted by mini-css-extract-plugin
var _1 = "ExternalLink_link__ce0Pv";
export { _1 as "link" }
